import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { CatalogedCompanySettingKey } from '~pages/Settings/Configuration/companySettingsCatalog';

import CompanySettingToggle from './CompanySettingToggle';
import DispatchTableColumnSettings from './DispatchTableColumnSettings';

interface DisplaySettingGroup {
  labelKey: string;
  settingKeys: CatalogedCompanySettingKey[];
}

const displaySettingGroups: DisplaySettingGroup[] = [
  {
    labelKey: 'page_headings.dispatch',
    settingKeys: [
      'sort_dispatch_orders_by_dispatch_number',
      'hide_driver_equipment_when_job_has_equipment',
      'show_dispatch_jobs_driver_labels',
      'collapse_dispatch_order_cards_by_default',
      'show_canceled_rejected_orders',
      'auto_assign_driver_equipment_to_jobs',
      'driver_require_all_permissions',
      'share_order_totals',
    ],
  },
  {
    labelKey: 'administration.configuration.settings.display.forms_and_filters',
    settingKeys: [
      'show_default_digital_ticket_view',
      'show_contract_number',
      'show_service_class',
      'show_driver_trailer',
      'require_order_name',
      'hide_project_external_id_in_order_name',
      'require_order_service_class',
      'require_approval_to_settle',
      'chase_missing_tickets_default_on',
      'live_eta_default',
      'running_default_on',
      'apply_rate_changes_default_on',
    ],
  },
  {
    labelKey:
      'administration.configuration.settings.display.project_and_order_requirements',
    settingKeys: [
      'require_department',
      'require_salesperson',
      'itemize_material_rate_default_on',
      'require_pickup_site',
      'require_material_rate',
      'require_rates_by_department_name',
      'require_tax',
    ],
  },
];

interface DisplaySettingsProps {
  settingKeys: CatalogedCompanySettingKey[];
}

export default function DisplaySettings({ settingKeys }: DisplaySettingsProps) {
  return (
    <>
      <Typography sx={{ color: 'text.secondary', mt: 0.5 }}>
        {t('administration.configuration.settings.display.description')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, mt: 4 }}>
        <DispatchTableColumnSettings settingKeys={settingKeys} />
        {displaySettingGroups.map((group) => {
          const visibleGroupSettingKeys = group.settingKeys.filter((key) =>
            settingKeys.includes(key),
          );

          if (visibleGroupSettingKeys.length === 0) {
            return null;
          }

          return (
            <Box key={group.labelKey}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {t(group.labelKey)}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
                {visibleGroupSettingKeys.map((key) => (
                  <CompanySettingToggle key={key} settingKey={key} />
                ))}
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
}
